import React from 'react';

import Card from '../../../../../components/Card/index';

const TrainingPostRegistration = ({ training }) => {
  return (
    <Card>
      <Card.Header>Thank you for registering for {training.name}</Card.Header>
      <Card.Body>
        In order to finish this training and obtain your badge, please finish your course on Canvas.
      </Card.Body>
    </Card>
  );
};

export default TrainingPostRegistration;
